export class FinishedEvent {
    constructor({ transfer, startedDate, finishedDate }) {
        this.name = 'finished';
        this.transfer = { ...transfer };
        this.startedDate = startedDate;
        this.finishedDate = finishedDate;
        this.duration = new Date(this.finishedDate).getTime() - new Date(this.startedDate).getTime();
    }
    get data() {
        return {
            transfer: this.transfer,
            finishedDate: this.finishedDate,
            duration: new Date(this.finishedDate).getTime() - new Date(this.startedDate).getTime(),
        };
    }
}
